'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from 'react';
const STORAGE_KEY_PREFIX = 'takeover_dismissed_';
const listeners = new Set<() => void>();
function readDismissed(url: string): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY_PREFIX + url) === 'true';
  } catch {
    return false;
  }
}
function subscribe(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return (): void => {
    listeners.delete(onStoreChange);
  };
}
function getServerSnapshot(): boolean {
  return false;
}
export function useDismissedTakeover(url) {
  const $ = _c(7);
  let t0;
  if ($[0] !== url) {
    t0 = () => readDismissed(url);
    $[0] = url;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isDismissed = useSyncExternalStore(subscribe, t0, getServerSnapshot);
  let t1;
  if ($[2] !== url) {
    t1 = () => {
      try {
        sessionStorage.setItem(STORAGE_KEY_PREFIX + url, "true");
      } catch {}
      listeners.forEach(_temp);
    };
    $[2] = url;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const dismiss = t1;
  let t2;
  if ($[4] !== dismiss || $[5] !== isDismissed) {
    t2 = [isDismissed, dismiss];
    $[4] = dismiss;
    $[5] = isDismissed;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(listener) {
  return listener();
}